<template>
  <span class="flex cursor-pointer gap-[1px] text-slate-800 w-2 h-2">
    <font-awesome-icon
      v-for="(icon, index) in icons"
      :key="index"
      size="xs"
      :icon="icon"
    />
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

interface Props {
  size: number;
}

const props = withDefaults(defineProps<Props>(), {
  size: 1,
});

const validatedSize = computed(() => {
  return Math.min(Math.max(props.size, 1), 3) as 1 | 2 | 3;
});

const icons = computed<["fas" | "far", string][]>(() => {
  return Array(3)
    .fill(null)
    .map((_, index) =>
      index < validatedSize.value ? ["fas", "square"] : ["far", "square"],
    );
});
</script>
